module.exports = __webpack_public_path__ + "static/media/copyIcon.97006482.svg";